import roller_raex_settings_gen_3 from '@devices/settings/common_settings/roller_raex_settings_gen_3';
import { addon_plus_devices_g3 } from '@devices/settings/device_settings/addon_sensors';

export default {
	name: 'RaexMP46',
	friendly_name: 'RAEX MP46 Curtain Motor',
	family: 'roller',
	isPM: false,
	addons: addon_plus_devices_g3,
	reset_from_input: true,
	modes: {
		roller: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			slider: true,
			settings: roller_raex_settings_gen_3,
		},
	},
};
